import * as React from "react";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { Phone } from "../../../../../../react-core/Html/Validation/RegExPatterns";
import { UKLandLinePhone } from "../../../../../../react-core/Html/Validation/RegExPatterns";
import { UKMobilePhone } from "../../../../../../react-core/Html/Validation/RegExPatterns";
import { ValidatorContents } from "../../../../Common/ValidatorHelper";
import { CustomerPhoneNumber } from "../../../../../../Wrap/Models/Models/Customer/CustomerPhoneNumber";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { CountryCodeMap } from "../../../../../Shared/Entities/Maps/CountryCodeMap";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { CustomerPhoneNumberType } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerPhoneNumberType";
import { PhoneNumber } from "../../../../../../Wrap/Models/Domains/PhoneNumber/PhoneNumber";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { CountryCode } from "../../../../../../Wrap/Constants/Enums/Domain/CountryCode";

interface IPhoneNumberDetailsProps extends IProcessComponentProps {
    data: Array<CustomerPhoneNumber>;
    onChange: (changes: Array<CustomerPhoneNumber>) => void;
    disabled?: boolean;
}

interface IPhoneNumberDetailsState {
    phoneNumbers: Array<CustomerPhoneNumber>;
    selectedCountryLandLine: CountryCode;
    selectedCountryMobile: CountryCode;
}

export class PhoneNumberDetails extends ProcessComponent<IPhoneNumberDetailsProps, IPhoneNumberDetailsState> {
    constructor(props: IPhoneNumberDetailsProps) {
        super(props);
        this.state = {
            phoneNumbers: props.data,
            selectedCountryLandLine:
                props.data &&
                props.data.find((ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Home) &&
                props.data.find((ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Home).PhoneNumber
                    ? props.data.find((ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Home).PhoneNumber.Country
                    : CountryCode.GBR,
            selectedCountryMobile:
                props.data &&
                props.data.find((ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Mobile) &&
                props.data.find((ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Mobile).PhoneNumber
                    ? props.data.find((ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Mobile).PhoneNumber
                          .Country
                    : CountryCode.GBR,
        };
    }

    componentDidUpdate(prevProps: IPhoneNumberDetailsProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps?.data !== this.props?.data && this.props?.data) {
            const homePhone = this.props?.data.find(
                (ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Home
            );
            const mobilePhone = this.props?.data.find(
                (ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Mobile
            );

            this.setState({
                phoneNumbers: this.props?.data,
                selectedCountryLandLine: homePhone?.PhoneNumber?.Country ?? CountryCode.GBR,
                selectedCountryMobile: mobilePhone?.PhoneNumber?.Country ?? CountryCode.GBR,
            });
        }
    }

    private onChangePhoneNumberLandLine(
        changes,
        phoneNumberType: CustomerPhoneNumberType,
        phoneNumberData: PhoneNumber,
        defaultCountry: CountryCode
    ) {
        const _data = JSON.parse(JSON.stringify(phoneNumberData ? phoneNumberData : {}));
        for (const key in changes) {
            _data[key] = changes[key];
        }

        let _originData = this.props.data || [];
        const index = _originData.findIndex((ele) => ele.PhoneNumberType === phoneNumberType);
        if (index >= 0) {
            if (CommonHelper.isNullOrEmpty(_data["Number"])) {
                // Remove number, remove both counrty and number
                _originData[index].PhoneNumber = { Country: null, Number: null };
            } else {
                _originData[index].PhoneNumber = _data;
            }
            if (CommonHelper.isNullOrEmpty(_data["Country"])) {
                _data["Country"] = defaultCountry;
            }
        } else {
            if (CommonHelper.isNullOrEmpty(_data["Country"])) {
                _data["Country"] = defaultCountry;
            }
            _originData.push({ PhoneNumber: _data, PhoneNumberType: phoneNumberType });
        }
        _originData = _originData.filter(
            (ele) => ele?.PhoneNumber?.Country != null && !CommonHelper.isNullOrEmpty(ele?.PhoneNumber?.Number)
        );

        this.setState({ phoneNumbers: _originData, selectedCountryLandLine: _data["Country"] });
        this.props.onChange(_originData);
    }

    private onChangePhoneNumberMobile(
        changes,
        phoneNumberType: CustomerPhoneNumberType,
        phoneNumberData: PhoneNumber,
        defaultCountry: CountryCode
    ) {
        const _data = JSON.parse(JSON.stringify(phoneNumberData ? phoneNumberData : {}));
        for (const key in changes) {
            _data[key] = changes[key];
        }

        let _originData = this.props.data || [];
        const index = _originData.findIndex((ele) => ele.PhoneNumberType === phoneNumberType);
        if (index >= 0) {
            if (CommonHelper.isNullOrEmpty(_data["Number"])) {
                // Remove number, remove both counrty and number
                _originData[index].PhoneNumber = { Country: null, Number: null };
            } else {
                _originData[index].PhoneNumber = _data;
            }
            if (CommonHelper.isNullOrEmpty(_data["Country"])) {
                _data["Country"] = defaultCountry;
            }
        } else {
            if (CommonHelper.isNullOrEmpty(_data["Country"])) {
                _data["Country"] = defaultCountry;
            }
            _originData.push({ PhoneNumber: _data, PhoneNumberType: phoneNumberType });
        }
        _originData = _originData.filter(
            (ele) => ele?.PhoneNumber?.Country != null && !CommonHelper.isNullOrEmpty(ele?.PhoneNumber?.Number)
        );
        this.setState({ phoneNumbers: _originData, selectedCountryMobile: _data["Country"] });
        this.props.onChange(_originData);
    }

    private renderEditPhoneNumLandLine(data: CustomerPhoneNumber, disabled: boolean): JSX.Element {
        return (
            <div className="row narrow-gutter">
                <div className="col-auto">
                    <SelectEditor
                        options={CountryCodeMap.getArray()}
                        getText={(v) => {
                            return CountryCodeMap.getString(v);
                        }}
                        required={data?.PhoneNumber?.Number ? "Please select country" : null}
                        disabled={disabled}
                        label="Country"
                        alwaysValidateOnUpdate
                        cssWrapper="control-size-180"
                        selected={data?.PhoneNumber?.Country ?? CountryCode.GBR}
                        placeholder={"Please select"}
                        onChange={(v) =>

                            this.onChangePhoneNumberLandLine(
                                { Country: v },
                                data?.PhoneNumberType,
                                data?.PhoneNumber,
                                CountryCode.GBR
                            )
                        }
                    />
                </div>
                {this.state.selectedCountryLandLine == CountryCode.GBR && (
                    <div className="col-auto">
                        <TextBoxEditor
                            disabled={disabled}
                            label={
                                data?.PhoneNumberType === CustomerPhoneNumberType.Home
                                    ? `Landline number (optional)`
                                    : "Mobile number (optional)"
                            }
                            value={data?.PhoneNumber?.Number}
                            maxLength={20}
                            alwaysValidateOnUpdate={false}
                            cssWrapper="control-size-245"
                            regex={{ errorMessage: ValidatorContents.InvalidUKLandLinePhone, value: UKLandLinePhone }}
                            onBlur={(v) => {
                                this.onChangePhoneNumberLandLine(
                                    { Number: (v ?? "").trim() },
                                    data?.PhoneNumberType,
                                    data?.PhoneNumber,
                                    CountryCode.GBR
                                );
                            }}

                        />
                    </div>
                )}

                {this.state.selectedCountryLandLine != CountryCode.GBR && (
                    <div className="col-auto">
                        <TextBoxEditor
                            disabled={disabled}
                            label={
                                data?.PhoneNumberType === CustomerPhoneNumberType.Home
                                    ? `Landline number (optional)`
                                    : "Mobile number (optional)"
                            }
                            value={data?.PhoneNumber?.Number}
                            maxLength={20}
                            alwaysValidateOnUpdate
                            cssWrapper="control-size-245"
                            regex={{ errorMessage: ValidatorContents.InvalidPhone, value: Phone }}
                            onChange={(v) =>
                                this.onChangePhoneNumberLandLine(
                                    { Number: v },
                                    data?.PhoneNumberType,
                                    data?.PhoneNumber,
                                    CountryCode.GBR
                                )
                            }
                        />
                    </div>
                )}
            </div>
        );
    }

    private renderEditPhoneNumMobile(data: CustomerPhoneNumber, disabled: boolean): JSX.Element {
        return (
            <div className="row narrow-gutter">
                <div className="col-auto">
                    <SelectEditor
                        options={CountryCodeMap.getArray()}
                        getText={(v) => {
                            return CountryCodeMap.getString(v);
                        }}
                        required={data?.PhoneNumber?.Number ? "Please select country" : null}
                        disabled={disabled}
                        label="Country"
                        alwaysValidateOnUpdate
                        cssWrapper="control-size-180"
                        selected={data?.PhoneNumber?.Country ?? CountryCode.GBR}
                        placeholder={"Please select"}
                        onChange={(v) =>
                            this.onChangePhoneNumberMobile(
                                { Country: v },
                                data?.PhoneNumberType,
                                data?.PhoneNumber,
                                CountryCode.GBR
                            )
                        }
                    />
                </div>
                {this.state.selectedCountryMobile == CountryCode.GBR && (
                    <div className="col-auto">
                        <TextBoxEditor
                            disabled={disabled}
                            label={
                                data?.PhoneNumberType === CustomerPhoneNumberType.Home
                                    ? `Landline number (optional)`
                                    : "Mobile number (optional)"
                            }
                            value={data?.PhoneNumber?.Number}
                            maxLength={20}
                            alwaysValidateOnUpdate={false}
                            cssWrapper="control-size-245"
                            regex={{ errorMessage: ValidatorContents.InvalidUKMobilePhone, value: UKMobilePhone }}
                            onBlur={(v) => {
                                this.onChangePhoneNumberMobile(
                                    { Number: (v ?? "").trim() },
                                    data?.PhoneNumberType,
                                    data?.PhoneNumber,
                                    CountryCode.GBR
                                );
                            }}

                        />
                    </div>
                )}

                {this.state.selectedCountryMobile != CountryCode.GBR && (
                    <div className="col-auto">
                        <TextBoxEditor
                            disabled={disabled}
                            label={
                                data?.PhoneNumberType === CustomerPhoneNumberType.Home
                                    ? `Landline number (optional)`
                                    : "Mobile number (optional)"
                            }
                            value={data?.PhoneNumber?.Number}
                            maxLength={20}
                            alwaysValidateOnUpdate
                            cssWrapper="control-size-245"
                            regex={{ errorMessage: ValidatorContents.InvalidPhone, value: Phone }}
                            onChange={(v) =>
                                this.onChangePhoneNumberMobile(
                                    { Number: v },
                                    data?.PhoneNumberType,
                                    data?.PhoneNumber,
                                    CountryCode.GBR
                                )
                            }
                        />
                    </div>
                )}
            </div>
        );
    }

    render() {  
        const { disabled } = this.props;
        const { phoneNumbers } = this.state;
        const landline: CustomerPhoneNumber = (phoneNumbers || []).find(
            (ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Home
        ) || { PhoneNumberType: CustomerPhoneNumberType.Home };
        const mobile: CustomerPhoneNumber = (phoneNumbers || []).find(
            (ele) => ele.PhoneNumberType === CustomerPhoneNumberType.Mobile
        ) || { PhoneNumberType: CustomerPhoneNumberType.Mobile };
        return (
            <>
                <h3>Phone</h3>
                <p id="Hint1" className="text-size-14 mb-24">
                    When entering Phone number, please enter this without International Area code
                </p>
                {this.renderEditPhoneNumLandLine(landline, disabled)}
                {this.renderEditPhoneNumMobile(mobile, disabled)}
            </>
        );
    }
}
